import React from 'react';
import { Image, View } from "react-native"
import { Text } from '../../../globalComponents/NativeOverrides';
import { ArticleProps } from "../../../store/types/soc_svc"
import StreamCard from '../components/StreamCard';

type InstaArticleProps = {
    article:ArticleProps,
    width:number,
    onSelect: (artice:ArticleProps) => void
}
const InstaArticle = ({ article, width, onSelect }:InstaArticleProps) => {

    if(article.source != 'instagram'){ return <></> }
    if(!article.image){ return <></> }
    return (
        <View>
            {article.article_type == 'video' ?
            <View>
                <StreamCard
                    url={article.url}
                    width={width}
                    id={article.url}
                    stream_type='instagram'
                />
            </View>
            :<></>}
        </View>
    )
}

export default InstaArticle